import React from "react";

export default function NoMatch() {
  return (
    <div>
      <h1>
        No wishes here. Looks like you've gone too far down the rabbit hole.
      </h1>
    </div>
  );
}
